import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { RefObject } from "react";

import materialCore from "../../core/material.core";
import Dialog from "../form/dialog.comp";

export default function DeleteMaterialDialog({
  dialogRef,
  materialId,
}: {
  dialogRef: RefObject<HTMLDialogElement>;
  materialId: string;
}) {
  const queryClient = useQueryClient();
  const { isReady } = useRouter();

  async function clickConfirmed() {
    const data = await materialCore.deleteMaterial(materialId);

    if (data.message === "success") {
      queryClient.invalidateQueries({ queryKey: ["materials"] });
    }
  }

  if (!isReady) return null;

  return (
    <>
      <Dialog
        title="Delete Product"
        message={`Are You sure to delete this product?`}
        dialogRef={dialogRef}
        confirm={clickConfirmed}
      />
    </>
  );
}
